import { b as __makeTemplateObject } from './_tslib-4c7d6ae2.js';
import React__default, { useState, useEffect } from 'react';
import styled from 'styled-components';

var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-filter: ", "; /* Safari 6.0 - 9.0 */\n  filter: ", ";\n  -webkit-transition: filter .25s ease-in-out;\n  transition: filter .25s ease-in-out;\n  width: ", ";\n"], ["\n  -webkit-filter: ", "; /* Safari 6.0 - 9.0 */\n  filter: ", ";\n  -webkit-transition: filter .25s ease-in-out;\n  transition: filter .25s ease-in-out;\n  width: ", ";\n"])), function (_a) {
    var useLowResolution = _a.useLowResolution;
    return useLowResolution ? "blur(5px)" : 'none';
}, function (_a) {
    var useLowResolution = _a.useLowResolution;
    return useLowResolution ? "blur(5px)" : 'none';
}, function (_a) {
    var fullWidth = _a.fullWidth;
    return fullWidth ? '100%' : undefined;
});
var Cache = {};
var ImageBlur = function (_a) {
    var alt = _a.alt, className = _a.className, lowResolutionSrc = _a.lowResolutionSrc, src = _a.src, fullWidth = _a.fullWidth;
    var _b = useState(!!lowResolutionSrc && !Cache[src]), useLowResolution = _b[0], setUseLowResolution = _b[1];
    useEffect(function () {
        var highResolutionImage = document.createElement('img');
        highResolutionImage.src = src;
        highResolutionImage.onload = function () {
            setUseLowResolution(false);
            Cache[src] = true;
            highResolutionImage = null;
        };
        return function () {
            highResolutionImage = null;
        };
    }, []);
    return (React__default.createElement(StyledImage, { alt: alt, className: className, src: useLowResolution ? lowResolutionSrc : src, useLowResolution: useLowResolution, fullWidth: fullWidth }));
};
var templateObject_1;

export { ImageBlur as I };
//# sourceMappingURL=ImageBlur-39da387d.js.map
